module.exports = __webpack_public_path__ + "img/1753839515980-WhatsApp Image 2025-07-30 at 09.29.49 1.jpeg.bf75a91d.webp";